import React, { useContext } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Card, Col, Row } from "react-bootstrap";

import CenterSpinner from "components/CenterSpinner";

import { sections, useSection } from "hooks/section";
import { useAdsChaoticOrder } from "hooks/query";

import "./StudyPlaces.css";
// import useSearch from "hooks/search";
// import { AdSearch } from "components/AdSearchManager/AdSearch";
// import { SearchContext } from "components/AdSearchManager/SearchContext";
import { SearchContext } from "components/AdSearchManager/SearchContext";

export default function StudyPlaces() {
    const { data, isSuccess, isLoading } = useAdsChaoticOrder();
    const { sectionEnum, sectionUrl } = useSection();
    const { searchState } = useContext(SearchContext);

    const [searchParams, setSearchParams] = useSearchParams();

    const settings = {
        dots: false,
        draggable: false,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical: true,
        pauseOnHover: true,
    };

    const filterFreeStudyPlaces = () => {
        searchState.filters.find((f) => f.header === "STUDIEPLATSER").data = ["Studieplatser finns"];
        // let xresults = AdSearch(adCache.data, searchState.filters, searchState.relations, searchState.freetext, db);
        searchParams.set("availableStudentSlots", "Studieplatser finns");
        setSearchParams(searchParams);
        //setResults(xresults);
    };

    if (sectionEnum === sections.EFTERGYMASIAL_UTBILDNING) {
        return (
            <div className="StudyPlaces">
                <h2 className="mb-3">Lediga studieplatser</h2>
                <a className="linkColor margin" onClick={() => filterFreeStudyPlaces()}>
                    {" "}
                    Se alla Lediga studieplatser{" "}
                </a>

                <ul>
                    <Slider {...settings}>
                        {isLoading && <CenterSpinner />}

                        {isSuccess &&
                            data.availableStudentSlots.$values.map((value) => {
                                return <Item key={value.slug} educator={{ ...value }} />;
                            })}
                    </Slider>
                </ul>
            </div>
        );
    }

    return false;
}

function Item({ educator }) {
    return (
        <li>
            <Link to={"/utbildning/" + educator.slug}>
                <Card>
                    <Card.Body>
                        <Row>
                            <Col sm={9} xs={7}>
                                <Card.Title>{educator.title}</Card.Title>
                            </Col>
                            <Col sm={3} xs={5}>
                                <Card.Img src={educator.logoUrl} alt="Logo" />
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Link>
        </li>
    );
}
